"use client";

import { Input } from "@headlessui/react";
import { useEffect, useState } from "react";
import Pagination from "./Pagination";
import { fetchAllUsersDetails } from "../apiCalls/usersApi";

/**
 * limit = page size, offset = page index * page size (API expects offset, not page number).
 */
const SelectDetailsPatient = ({ setData, setLoading, setError }) => {
  const [draftSearch, setDraftSearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(8);

  // Debounce search text; empty clears immediately (no artificial delay on first paint).
  useEffect(() => {
    if (draftSearch === "") {
      setAppliedSearch("");
      setPage(0);
      return;
    }
    const t = setTimeout(() => {
      setAppliedSearch(draftSearch);
      setPage(0);
    }, 350);
    return () => clearTimeout(t);
  }, [draftSearch]);

  useEffect(() => {
    const offset = Number(page) * Number(pageSize);
    fetchAllUsersDetails(
      pageSize,
      offset,
      appliedSearch,
      setLoading,
      setError,
      setData
    );
  }, [page, pageSize, appliedSearch, setLoading, setError, setData]);

  return (
    <div className="flex w-full min-w-0 flex-col gap-2 sm:flex-row sm:items-stretch sm:gap-3">
      <div className="min-w-0 flex-1">
        <Input
          placeholder="Zoeken"
          className="block h-11 w-full rounded-xl border border-wa-border bg-wa-panel2 py-2.5 pl-3 pr-3 text-sm text-wa-text outline-none ring-0 placeholder:text-wa-text/55 focus:border-wa-accent focus:ring-1 focus:ring-wa-accent sm:text-sm/6"
          value={draftSearch}
          onChange={(event) => setDraftSearch(event.target.value)}
        />
      </div>
      <div className="w-full flex-shrink-0 sm:w-auto sm:min-w-[280px] sm:max-w-md">
        <Pagination
          variant="compact"
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageRanges={[8, 16, 32, 64, 128, 256]}
        />
      </div>
    </div>
  );
};

export default SelectDetailsPatient;
